// in src/Dashboard.js
import * as React from 'react';
import { Card, CardContent, CardHeader } from '@material-ui/core';

export default () => (
  <Card>
    <CardHeader title="Welcome to Vibbes.tv administrative website." />
    <CardContent>
      To get started please start by adding one or more Artists, then Add your Visual Artworks in the Artworks module. <br/>
      Once submitted the viBBes team will promptly review your content and publish it upon approval. <br/><br/>
      Thank you for being part of viBBes!
    </CardContent>
  </Card>
);
